require('../../lib/polyfill')
const omniture = require('../../lib/omniture')
const constants = require('../common/constants')
const helpers = require('../common/helpers')

module.exports.firePageTrackingWithContext = function (userObj, trackObj) {
  omniture.trackPageWithContext(
    helpers.getPageContextObject(userObj, trackObj, constants.creContextPrefix)
  )
}
